import { ContractIAImportState } from '../../states/Contract.IAImport.States';
import ContractIAImportCreateReducer from './ContractIAImport.Create.Reducer';
import ContractIAImportGetLastReducer from './ContractIAImport.GetLast.Reducer';
import * as CommonFunctions from '../Common/Functions';

export const CombinedContractIAImportReducer = CommonFunctions.reduceReducers<ContractIAImportState>(
  ContractIAImportGetLastReducer,
  ContractIAImportCreateReducer,
);
